import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard-main" }
const _hoisted_2 = { class: "sticky top-0 z-20 border-b border-white/10 bg-brand-900/80 backdrop-blur" }
const _hoisted_3 = { class: "mx-auto flex min-h-[74px] max-w-[1600px] items-center justify-between gap-3 px-3 py-2 sm:px-4 lg:px-6" }
const _hoisted_4 = { class: "flex min-w-0 items-center gap-2.5 text-white" }
const _hoisted_5 = { class: "hidden min-h-10 shrink-0 items-center gap-2 rounded-full border border-white/15 bg-white/10 px-2.5 py-1.5 text-white md:flex" }
const _hoisted_6 = { class: "grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white text-xs font-bold text-brand-700" }
const _hoisted_7 = { class: "max-w-[220px] text-left leading-none" }
const _hoisted_8 = { class: "truncate text-xs font-semibold leading-4" }
const _hoisted_9 = { class: "truncate text-[11px] leading-3 text-blue-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiToastHost = _resolveComponent("UiToastHost")!
  const _component_LoginPage = _resolveComponent("LoginPage")!
  const _component_TopNavBar = _resolveComponent("TopNavBar")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UiToastHost),
    ($setup.showLogin)
      ? (_openBlock(), _createBlock(_component_LoginPage, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
      'dashboard-shell',
      $setup.sidebarCollapsed
        ? 'lg:grid-cols-[88px_minmax(0,1fr)]'
        : 'lg:grid-cols-[280px_minmax(0,1fr)]',
    ])
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              ($setup.mobileOpen)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "fixed inset-0 z-30 bg-slate-950/50 lg:hidden",
                    "aria-label": "Đóng menu",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mobileOpen = false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("aside", {
            class: _normalizeClass([
        'fixed inset-y-0 left-0 z-40 w-[280px] transform transition-all duration-200 lg:static lg:translate-x-0',
        $setup.sidebarCollapsed ? 'lg:w-[88px]' : 'lg:w-[280px]',
        $setup.mobileOpen ? 'translate-x-0' : '-translate-x-full',
      ])
          }, [
            _createVNode(_component_TopNavBar, {
              "full-name": $setup.fullName,
              team: $setup.team,
              collapsed: $setup.sidebarCollapsed,
              onToggleCollapse: _cache[1] || (_cache[1] = ($event: any) => ($setup.sidebarCollapsed = !$setup.sidebarCollapsed)),
              onNavigate: _cache[2] || (_cache[2] = ($event: any) => ($setup.mobileOpen = false))
            }, null, 8, ["full-name", "team", "collapsed"])
          ], 2),
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_UiButton, {
                    variant: "ghost",
                    size: "icon",
                    icon: "menu",
                    class: "bg-white/10 text-white hover:bg-white/20 lg:hidden",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mobileOpen = true))
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "min-w-0 text-left leading-none" }, [
                    _createElementVNode("p", { class: "truncate text-xs font-medium leading-4 text-blue-100" }, " Hệ thống quản lý tài sản "),
                    _createElementVNode("p", { class: "mt-0.5 truncate text-lg font-black leading-7" }, " Dashboard vận hành ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString($setup.initials), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString($setup.fullName || "Người dùng"), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString($setup.team || "Chưa có khoa/phòng"), 1)
                  ])
                ])
              ])
            ]),
            _createVNode(_component_router_view)
          ])
        ], 2))
  ], 64))
}